export default "__VITE_ASSET__4844c708__"